import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-065e4028"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "iframe-wrapper" }
const _hoisted_2 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: _ctx.landingUrl,
      title: _ctx.isAex ? 'AEX' : 'MEX',
      class: "landing-iframe"
    }, null, 8, _hoisted_2)
  ]))
}